module.exports = __webpack_public_path__ + "static/media/student_1f9d1-200d-1f393.0e17ca7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/student_1f9d1-200d-1f393.png
// module id = 727
// module chunks = 2